var mySwiper = new Swiper('.bnr-slide__container', {
	// Optional parameters
	// direction: 'vertical',
	loop: true,
	slidesPerView: 1,
	spaceBetween: 22,
	centeredSlides: true,
	speed: 900,
	autoplay: {
		delay: 4000,
	},

	// If we need pagination
	pagination: {
		el: '.swiper-pagination',
	},

	// Navigation arrows
	navigation: {
		nextEl: '.bnr-slide .swiper-button-next',
		prevEl: '.bnr-slide .swiper-button-prev',
	},

	// And if we need scrollbar
	// scrollbar: {
	// 	el: '.swiper-scrollbar',
	// },
	breakpoints: {
        768: {
          slidesPerView: 2,
        }
      }
});

var mySwiper = new Swiper('.p-pickup__slider', {
	// Optional parameters
	// direction: 'vertical',
	loop: true,
	slidesPerView: 1,
	spaceBetween: 10,
	effect: 'fade',
	speed: 900,
	autoHeight: true,
	autoplay: {
		delay: 4000,
	},

	// If we need pagination
	pagination: {
		el: '.swiper-pagination',
	},

	// Navigation arrows
	navigation: {
		nextEl: '.p-pickup .swiper-button-next',
		prevEl: '.p-pickup .swiper-button-prev',
	}
});



var swiper = new Swiper('.p-mainvisual__container', {
	// Optional parameters
	// direction: 'vertical',
	loop: true,
	slidesPerView: 1,
	spaceBetween: 10,
	speed: 800,
	centeredSlides: true,
	autoplay: {
		delay: 3000,
	},


	// If we need pagination
	pagination: {
		el: '.swiper-pagination',
	},

	// Navigation arrows
	navigation: {
		nextEl: '.p-mainvisual .swiper-button-next',
		prevEl: '.p-mainvisual .swiper-button-prev',
	},

	// And if we need scrollbar
	// scrollbar: {
	// 	el: '.swiper-scrollbar',
	// },
	breakpoints: {
        768: {
			slidesPerView:1.1,
			spaceBetween: 24,
		}
      }
})